import { FormularioService } from 'src/app/services/formulario.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormDto } from '../../../model/form-dto';
import { FormuleFormDto } from '../../../model/formule-form-dto';
import { MockForm, MockFormuleForm } from '../../../model/mock-form';
import $ from "jquery";
import { FormFormuleService } from '../../../service/form-formule.service';
import { SimpleModalComponent } from 'src/app/shared/simple-modal/simple-modal.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-list-formule-form',
  templateUrl: './list-formule-form.component.html',
  styleUrls: ['./list-formule-form.component.scss']
})
export class ListFormuleFormComponent implements OnInit {

  form: FormDto = new FormDto();
  formuleList: FormuleFormDto[] = [];
  isUserDev: boolean = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private service: FormFormuleService,
    protected formularioService: FormularioService,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.getUser();
    this.getFormule();
    this.getForm();
  }

  getForm = async () => {
    this.form.id = Number(this.route.snapshot.params['form']);
    let get = await this.service.getById(this.form.id);
    this.form = get[0];
  }

  getFormule = async () => {
    this.form.id = Number(this.route.snapshot.params['form']);
    this.formuleList = await this.service.getFormuleByIdForm(this.form.id);
  }

  openFormule = (id) => {
    var d = document.getElementById("collapse_" + id);
    let hasHide = d.classList.length === 2;
    if (!hasHide) d.classList.add('show');
    else d.classList.remove('show')
  }

  backList = () => {
    this.router.navigateByUrl('adm/form/list');
  }

  goNewFormule = () => {
    this.router.navigateByUrl('adm/form/new-formule/' + this.form.id);
  }

  goEditFormule = (idFormule) => {
    this.router.navigateByUrl('adm/form/edit-formule/' + idFormule);
  }

  getUser = async () => {
    await this.service.getUserCwid()
      .then(res => {
        if (res.length > 0) this.isUserDev = true;
        else {
          this.formularioService.userIsAdmin().subscribe(adm => {
            if (adm) this.isUserDev = true;
            else {
              this.formularioService.userIsManager().subscribe(manager => {
                if (manager) this.isUserDev = true;
                else this.isUserDev = false;
              })
            }
          })
        }
      })
      .catch(err => {
        console.error(err);
      })


  }

  showDeleteFormule = (idFormule) => {
    const dialogRef = this.dialog.open(SimpleModalComponent, {
      data: {
        title: 'Excluir',
        mensage: 'Deseja realmente excluir essa Fórmula?',
        titleBtn1: 'Não',
        titleBtn2: 'Sim',
      },
    });

    dialogRef.afterClosed().subscribe(async (result) => {
      if (result) {
        this.deleteFormule(idFormule);
      }
    });
  }

  deleteFormule = (idFormule) => {
    this.service.deleteFormule(idFormule)
      .then(async res => {
        await this.getFormule();
      })
      .catch(err => {
        console.error(err);
      })
  }

}
